const PRODUCT_GROUPS_BASE_URL = '/product-groups';

export const routeCreator = {
  list: () => PRODUCT_GROUPS_BASE_URL,
  create: () => `${PRODUCT_GROUPS_BASE_URL}/create`,
  details: (id: string) => `${PRODUCT_GROUPS_BASE_URL}/${id}`,
  update: (id: string) => `${PRODUCT_GROUPS_BASE_URL}/${id}/update`,
};

export const parseSortingRank = (sortingRank: number | string | undefined) => {
  const parsedSortingRank = Number(sortingRank);
  const isSortingRankValid = !Number.isNaN(parsedSortingRank);

  return isSortingRankValid ? parsedSortingRank : undefined;
};
